import { render, staticRenderFns } from "./SearchTextInput.vue?vue&type=template&id=08875ed3&scoped=true&"
import script from "./SearchTextInput.vue?vue&type=script&lang=js&"
export * from "./SearchTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08875ed3",
  null
  
)

export default component.exports